
























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { IntentListItemViewModel } from '@/features/bots/models/intents/intentListItemViewModel';
import AddIntentModal from '@/features/bots/components/designer/AddIntentModal.vue';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import { IntentViewModel } from '@/features/bots/models/intents/intentViewModel';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { ConditionViewModel } from '@/shared/components/conditions/models/conditionViewModel';
import { LOAD_INTENTS } from '@/store/intents/actionTypes';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import Toast from '@/shared/services/toast';
import { TriggerConditionAttributeType } from '@/features/bots/components/designer/Conditions/triggerConditionsManager';

@Component({
	mixins: [validationMixin],
	validations: {
		liveCondition: {
			value: { required }
		},
	},
	components: {
		AddIntentModal,
		AddIcon,
		LoadingSpinner
	}
})
export default class IntentCondition extends Vue {
	@Getter public intents!: IntentListItemViewModel[];
	@Action(LOAD_INTENTS) public loadIntents: (forceLoad?: boolean) => Promise<void>;
	@Prop() public condition: ConditionViewModel;

	public selectedIntentId: string = '';
	public isLoading: boolean = false;

	public liveCondition: ConditionViewModel = {
		attribute: TriggerConditionAttributeType.MessageIntent,
		operation: '',
		type: '',
		value: '',
		result: true
	};

	public async mounted() {
		this.isLoading = true;
		try {
			await this.loadIntents();
		} catch {
			Toast.showError('Failed to load intents');
		}
		this.isLoading = false;

		if (this.condition) {
			this.liveCondition = {
				attribute: TriggerConditionAttributeType.MessageIntent,
				operation: 'equals',
				type: this.condition.type,
				value: this.condition.value,
				result: this.condition.result,
				unit: this.condition.unit,
				invalid: this.condition.invalid
			};

			if (this.liveCondition.invalid) {
				this.$v.$touch();
			}
		}

		this.emitConditionChanged();
	}

	public get intentsForFlows() {
		return this.intents.filter(e => e.id !== 'None');
	}

	public async chooseIntent(intent: IntentListItemViewModel) {
		this.selectedIntentId = intent.id;
		this.chosenIntent();
	}

	public addNewIntent() {
		const modal: any = this.$refs.intentConditionAddModal;
		if (modal) {
			modal.addNewIntent();
		}
	}

	public addedIntent(intent: IntentViewModel) {
		this.selectedIntentId = intent.id;
		this.chosenIntent();
	}

	public cancelled() {
		this.complete();
	}

	private chosenIntent() {
		this.liveCondition.value = this.selectedIntentId;
		this.complete();
	}

	private emitConditionChanged() {
		this.liveCondition.invalid = this.$v.$invalid;
		this.$emit('changed', this.liveCondition);
	}

	private complete() {
		this.liveCondition.invalid = this.$v.$invalid;
		this.$emit('completed', this.liveCondition);
	}
}
